/**
 * Returns true if any report in reportsResponse has at least one outcome response for the given question id.
 * Use when you have an array of survey/report objects (each with .responses).
 * @param {Array} reportsResponse - Array of report/survey objects (each with .responses)
 * @param {string|number} questionId - Outcome question id (matches r.q in employee_outcomes.responses)
 * @returns {boolean}
 */
export const hasOutcomeResponses = (reportsResponse, questionId) => {
  if (!reportsResponse?.length) return false;
  return reportsResponse.some((report) =>
    (report.responses || []).some((set) =>
      (set?.response?.employee_outcomes?.responses || []).some(
        (r) => Number(r.q) === Number(questionId)
      )
    )
  );
};

/**
 * Returns true if any response in the flat array has an outcome response for the given question id.
 * Use when you have the flat array of response objects used to build the table (e.g. dataToUse[0] in Heatmap).
 * @param {Array} flatResponseArray - Array of response objects (each may have .employee_outcomes.responses)
 * @param {string|number} questionId - Outcome question id (matches r.q in employee_outcomes.responses)
 * @returns {boolean}
 */
export const hasOutcomeResponsesInFlatData = (flatResponseArray, questionId) => {
  if (!Array.isArray(flatResponseArray) || flatResponseArray.length === 0)
    return false;
  return flatResponseArray.some(
    (response) =>
      (response?.employee_outcomes?.responses || []).some(
        (r) => Number(r.q) === Number(questionId)
      )
  );
};
